// Import dependencies
import { builderFetch } from '@builder/core/utilities';

// Translatable strings
const strings = UncannyAutomator._core.i18n.core.itemFilter.updateFilters;

/**
 * Updates all the [action] filters.
 * This one, unlike the other update functions, updates all filters at the same time.
 *
 * @param {String} filters The [action] filters, in a JSON string
 * @return {Promise} The fetch promise
 */
const updateFilters = ( filters = '' ) => {
	// Save the recipe title
	return builderFetch( {
		endpoint: `actions_conditions_update`,
		method: 'POST',
		data: {
			// eslint-disable-next-line camelcase
			recipe_id: UncannyAutomator._recipe.recipe_id,
			// eslint-disable-next-line camelcase
			actions_conditions: filters,
		},
		snackbar: {
			loading: strings.updatingFilters,
			success: strings.filtersUpdated,
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( 'uap/builder/core/item/filter/update-filters', {
				detail: {
					actionsConditions: filters
				}
			} ) );
		}

		return response;
	} );
}

export default updateFilters;
